(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[5166],{

/***/ 96338:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(4405);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(77637);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39181);
/* harmony import */ var react_icons_md__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(49661);
/* harmony import */ var _PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(31083);
/* harmony import */ var _PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6__);








var countries = [
    {
        code: "AE",
        name: "UAE",
        dialCode: "+971",
        flag: "\uD83C\uDDE6\uD83C\uDDEA"
    },
    {
        code: "AU",
        name: "Australia",
        dialCode: "+61",
        flag: "\uD83C\uDDE6\uD83C\uDDFA"
    },
    {
        code: "BR",
        name: "Brazil",
        dialCode: "+55",
        flag: "\uD83C\uDDE7\uD83C\uDDF7"
    },
    {
        code: "US",
        name: "United States",
        dialCode: "+1",
        flag: "\uD83C\uDDFA\uD83C\uDDF8"
    },
    {
        code: "CN",
        name: "China",
        dialCode: "+86",
        flag: "\uD83C\uDDE8\uD83C\uDDF3"
    },
    {
        code: "DE",
        name: "Germany",
        dialCode: "+49",
        flag: "\uD83C\uDDE9\uD83C\uDDEA"
    },
    {
        code: "EG",
        name: "Egypt",
        dialCode: "+20",
        flag: "\uD83C\uDDEA\uD83C\uDDEC"
    },
    {
        code: "ES",
        name: "Spain",
        dialCode: "+34",
        flag: "\uD83C\uDDEA\uD83C\uDDF8"
    },
    {
        code: "FR",
        name: "France",
        dialCode: "+33",
        flag: "\uD83C\uDDEB\uD83C\uDDF7"
    },
    {
        code: "GB",
        name: "United Kingdom",
        dialCode: "+44",
        flag: "\uD83C\uDDEC\uD83C\uDDE7"
    },
    {
        code: "IN",
        name: "India",
        dialCode: "+91",
        flag: "\uD83C\uDDEE\uD83C\uDDF3"
    },
    {
        code: "IR",
        name: "Iran",
        dialCode: "+98",
        flag: "\uD83C\uDDEE\uD83C\uDDF7"
    },
    {
        code: "IT",
        name: "Italy",
        dialCode: "+39",
        flag: "\uD83C\uDDEE\uD83C\uDDF9"
    },
    {
        code: "JP",
        name: "Japan",
        dialCode: "+81",
        flag: "\uD83C\uDDEF\uD83C\uDDF5"
    },
    {
        code: "KR",
        name: "South Korea",
        dialCode: "+82",
        flag: "\uD83C\uDDF0\uD83C\uDDF7"
    },
    {
        code: "MX",
        name: "Mexico",
        dialCode: "+52",
        flag: "\uD83C\uDDF2\uD83C\uDDFD"
    },
    {
        code: "RU",
        name: "Russia",
        dialCode: "+7",
        flag: "\uD83C\uDDF7\uD83C\uDDFA"
    },
    {
        code: "SA",
        name: "Saudi Arabia",
        dialCode: "+966",
        flag: "\uD83C\uDDF8\uD83C\uDDE6"
    },
    {
        code: "TR",
        name: "Turkey",
        dialCode: "+90",
        flag: "\uD83C\uDDF9\uD83C\uDDF7"
    }, 
];
var PhoneNumberInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var label = _param.label, error = _param.error, helperText = _param.helperText, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _size = _param.size, size = _size === void 0 ? "md" : _size, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, _required = _param.required, required = _required === void 0 ? false : _required, _className = _param.className, className = _className === void 0 ? "" : _className, onCountryChange = _param.onCountryChange, onPhoneChange = _param.onPhoneChange, onChange = _param.onChange, defaultValue = _param.defaultValue, value = _param.value, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(_param, [
        "label",
        "error",
        "helperText",
        "variant",
        "size",
        "fullWidth",
        "required",
        "className",
        "onCountryChange",
        "onPhoneChange",
        "onChange",
        "defaultValue",
        "value"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(countries[0]), selectedCountry = _$ref[0], setSelectedCountry = _$ref[1];
    var _$ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), isDropdownOpen = _$ref1[0], setIsDropdownOpen = _$ref1[1];
    var _$ref2 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(""), phoneValue = _$ref2[0], setPhoneValue = _$ref2[1];
    var dropdownRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    // Parse defaultValue to extract country and phone number
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (defaultValue) {
            // Find matching country by dial code (try longest match first)
            var sortedCountries = countries.sort(function(a, b) {
                return b.dialCode.length - a.dialCode.length;
            });
            var matchingCountry = sortedCountries.find(function(country) {
                return defaultValue.startsWith(country.dialCode);
            });
            if (matchingCountry) {
                setSelectedCountry(matchingCountry);
                var phoneNumber = defaultValue.substring(matchingCountry.dialCode.length);
                setPhoneValue(phoneNumber);
            } else {
                // If no country code found, treat as phone number only
                setPhoneValue(defaultValue);
            }
        }
    }, [
        defaultValue
    ]);
    // Parse value prop to extract country and phone number (for Formik)
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (value && typeof value === "string") {
            // Find matching country by dial code (try longest match first)
            var sortedCountries = countries.sort(function(a, b) {
                return b.dialCode.length - a.dialCode.length;
            });
            var matchingCountry = sortedCountries.find(function(country) {
                return value.startsWith(country.dialCode);
            });
            if (matchingCountry) {
                setSelectedCountry(matchingCountry);
                var phoneNumber = value.substring(matchingCountry.dialCode.length);
                setPhoneValue(phoneNumber);
            } else {
                // If no country code found, treat as phone number only
                setPhoneValue(value);
            }
        } else {
            // Reset phone value when value prop is empty
            setPhoneValue("");
            setSelectedCountry(countries[0]);
        }
    }, [
        value
    ]);
    // Handle click outside to close dropdown
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        var handleClickOutside = function(event) {
            if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
                setIsDropdownOpen(false);
            }
        };
        if (isDropdownOpen) {
            document.addEventListener("mousedown", handleClickOutside);
        }
        return function() {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, [
        isDropdownOpen
    ]);
    var handleCountrySelect = function(country) {
        setSelectedCountry(country);
        setIsDropdownOpen(false);
        onCountryChange === null || onCountryChange === void 0 ? void 0 : onCountryChange(country);
        // Update phone number with new country code (only if there's a phone number)
        if (phoneValue && phoneValue.trim() !== "") {
            var fullPhoneNumber = country.dialCode + phoneValue;
            // Create synthetic event with full phone number for onChange
            if (onChange) {
                var syntheticEvent = {
                    target: {
                        value: fullPhoneNumber
                    },
                    currentTarget: {
                        value: fullPhoneNumber
                    }
                };
                onChange(syntheticEvent);
            }
        }
    };
    var handlePhoneChange = function(e) {
        var value = e.target.value;
        // Only allow numbers
        var numericValue = value.replace(/[^0-9]/g, "");
        setPhoneValue(numericValue);
        // Only send full phone number if there's actually a phone number
        var fullPhoneNumber = numericValue.trim() ? selectedCountry.dialCode + numericValue : "";
        onPhoneChange === null || onPhoneChange === void 0 ? void 0 : onPhoneChange(fullPhoneNumber);
        // Create synthetic event with full phone number for onChange
        if (onChange) {
            var syntheticEvent = (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, e), {
                target: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, e.target), {
                    value: fullPhoneNumber
                }),
                currentTarget: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({}, e.currentTarget), {
                    value: fullPhoneNumber
                })
            });
            onChange(syntheticEvent);
        }
    };
    var handleKeyDown = function(e) {
        // Allow: backspace, delete, tab, escape, enter, home, end, left, right, up, down
        if ([
            8,
            9,
            27,
            13,
            46,
            35,
            36,
            37,
            38,
            39,
            40
        ].indexOf(e.keyCode) !== -1 || // Allow Ctrl+A, Ctrl+C, Ctrl+V, Ctrl+X
        e.keyCode === 65 && e.ctrlKey === true || e.keyCode === 67 && e.ctrlKey === true || e.keyCode === 86 && e.ctrlKey === true || e.keyCode === 88 && e.ctrlKey === true) {
            return;
        }
        // Ensure that it is a number and stop the keypress
        if ((e.shiftKey || e.keyCode < 48 || e.keyCode > 57) && (e.keyCode < 96 || e.keyCode > 105)) {
            e.preventDefault();
        }
    };
    var inputClasses = [
        (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().input),
        error && (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().error),
        (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default())["size-".concat(size)],
        className
    ].filter(Boolean).join(" ");
    var containerClasses = [
        (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inputContainer),
        error && (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().error),
        (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default())["size-".concat(size)],
        fullWidth && (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().fullWidth), 
    ].filter(Boolean).join(" ");
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().inputField),
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                variant: "text-sm",
                as: "label",
                color: error ? "error" : "secondary",
                weight: "normal",
                className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().label),
                children: [
                    label,
                    required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().required),
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: containerClasses,
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                        className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().countrySelector),
                        ref: dropdownRef,
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                type: "button",
                                className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().countryButton),
                                onClick: function() {
                                    return setIsDropdownOpen(!isDropdownOpen);
                                },
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                        className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().countryCode),
                                        children: selectedCountry.code
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_icons_md__WEBPACK_IMPORTED_MODULE_7__/* .MdKeyboardArrowDown */ .Ix0, {
                                        size: 16,
                                        className: "".concat((_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dropdownIcon), " ").concat(isDropdownOpen ? (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().rotated) : "")
                                    })
                                ]
                            }),
                            isDropdownOpen && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dropdownMenu),
                                children: countries.map(function(country) {
                                    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("button", {
                                        type: "button",
                                        className: "".concat((_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().dropdownItem), " ").concat(selectedCountry.code === country.code ? (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().active) : ""),
                                        onClick: function() {
                                            return handleCountrySelect(country);
                                        },
                                        children: [
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().countryFlag),
                                                children: country.flag
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().countryName),
                                                children: country.name
                                            }),
                                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                                                className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().countryDialCode),
                                                children: country.dialCode
                                            })
                                        ]
                                    }, country.code);
                                })
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                        className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().divider)
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)({
                        ref: ref,
                        className: inputClasses,
                        type: "tel",
                        placeholder: "(555) 000-0000",
                        value: phoneValue,
                        onChange: handlePhoneChange,
                        onKeyDown: handleKeyDown
                    }, function() {
                        var _ = props.value, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(props, [
                            "value"
                        ]);
                        return restProps;
                    }()))
                ]
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                variant: "text-sm",
                as: "div",
                color: "error",
                weight: "normal",
                className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().errorMessage),
                children: error
            }),
            helperText && !error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                variant: "text-sm",
                as: "div",
                color: "disabled",
                weight: "normal",
                className: (_PhoneNumberInput_module_scss__WEBPACK_IMPORTED_MODULE_6___default().helperText),
                children: helperText
            })
        ]
    });
});
PhoneNumberInput.displayName = "PhoneNumberInput";
/* harmony default export */ __webpack_exports__["Z"] = (PhoneNumberInput);


/***/ }),

/***/ 5166:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(72006);
/* harmony import */ var _swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(77637);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(39181);
/* harmony import */ var _PhoneNumberInput__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(96338);
/* harmony import */ var _TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22083);
/* harmony import */ var _TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5__);







var TextInput = /*#__PURE__*/ (0,react__WEBPACK_IMPORTED_MODULE_1__.forwardRef)(function(_param, ref) {
    var label = _param.label, error = _param.error, helperText = _param.helperText, _variant = _param.variant, variant = _variant === void 0 ? "default" : _variant, _size = _param.size, size = _size === void 0 ? "md" : _size, _fullWidth = _param.fullWidth, fullWidth = _fullWidth === void 0 ? false : _fullWidth, icon = _param.icon, _iconPosition = _param.iconPosition, iconPosition = _iconPosition === void 0 ? "left" : _iconPosition, _required = _param.required, required = _required === void 0 ? false : _required, _multiline = _param.multiline, multiline = _multiline === void 0 ? false : _multiline, _rows = _param.rows, rows = _rows === void 0 ? 3 : _rows, _inputType = _param.inputType, inputType = _inputType === void 0 ? "default" : _inputType, leftElement = _param.leftElement, rightElement = _param.rightElement, _className = _param.className, className = _className === void 0 ? "" : _className, type = _param.type, props = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(_param, [
        "label",
        "error",
        "helperText",
        "variant",
        "size",
        "fullWidth",
        "icon",
        "iconPosition",
        "required",
        "multiline",
        "rows",
        "inputType",
        "leftElement",
        "rightElement",
        "className",
        "type"
    ]);
    var _$ref = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), showPassword = _$ref[0], setShowPassword = _$ref[1];
    var inputClasses = [
        multiline ? (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().textarea) : (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().input),
        error && (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().error),
        (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["inputType-".concat(inputType)],
        className, 
    ].filter(Boolean).join(" ");
    var containerClasses = [
        multiline ? (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().textareaContainer) : (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inputContainer),
        error && (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().error),
        (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default())["inputType-".concat(inputType)], 
    ].filter(Boolean).join(" ");
    var renderLeftElement = function() {
        if (leftElement) return leftElement;
        // Auto-generate icon based on inputType if no custom icon provided
        if (!icon && inputType === "email") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().iconLeft),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M2 4L8 8L14 4",
                            stroke: "#85888E",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "1",
                            y: "3",
                            width: "14",
                            height: "10",
                            rx: "2",
                            stroke: "#85888E",
                            strokeWidth: "1.5"
                        })
                    ]
                })
            });
        }
        if (!icon && inputType === "password") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().iconLeft),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M4 6V4C4 2.89543 4.89543 2 6 2H10C11.1046 2 12 2.89543 12 4V6",
                            stroke: "#85888E",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("rect", {
                            x: "2",
                            y: "6",
                            width: "12",
                            height: "8",
                            rx: "2",
                            stroke: "#85888E",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "8",
                            cy: "10",
                            r: "1.5",
                            fill: "#85888E"
                        })
                    ]
                })
            });
        }
        if (icon && iconPosition === "left") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().iconLeft),
                children: icon
            });
        }
        return null;
    };
    var renderRightElement = function() {
        if (rightElement) return rightElement;
        // Password toggle button
        if (inputType === "password") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("button", {
                type: "button",
                className: (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().passwordToggle),
                onClick: function() {
                    return setShowPassword(!showPassword);
                },
                "aria-label": showPassword ? "Hide password" : "Show password",
                children: showPassword ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M8 3C4.5 3 1.73 5.11 1 8C1.73 10.89 4.5 13 8 13C11.5 13 14.27 10.89 15 8C14.27 5.11 11.5 3 8 3Z",
                            stroke: "#85888E",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "8",
                            cy: "8",
                            r: "2",
                            stroke: "#85888E",
                            strokeWidth: "1.5"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M1 1L15 15",
                            stroke: "#85888E",
                            strokeWidth: "1.5",
                            strokeLinecap: "round"
                        })
                    ]
                }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M8 3C4.5 3 1.73 5.11 1 8C1.73 10.89 4.5 13 8 13C11.5 13 14.27 10.89 15 8C14.27 5.11 11.5 3 8 3Z",
                            stroke: "#85888E",
                            strokeWidth: "1.5",
                            strokeLinecap: "round",
                            strokeLinejoin: "round"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "8",
                            cy: "8",
                            r: "2",
                            stroke: "#85888E",
                            strokeWidth: "1.5"
                        })
                    ]
                })
            });
        }
        // Auto-generate help icon if no custom icon provided
        if (!icon && iconPosition === "right") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().iconRight),
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("svg", {
                    width: "16",
                    height: "16",
                    viewBox: "0 0 16 16",
                    fill: "none",
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("circle", {
                            cx: "8",
                            cy: "8",
                            r: "7",
                            stroke: "#85888E",
                            strokeWidth: "1"
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                            d: "M8 5.5V8L9.5 9.5",
                            stroke: "#85888E",
                            strokeWidth: "1",
                            strokeLinecap: "round"
                        })
                    ]
                })
            });
        }
        if (icon && iconPosition === "right") {
            return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                className: (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().iconRight),
                children: icon
            });
        }
        return null;
    };
    // If inputType is phone, render PhoneNumberInput
    if (inputType === "phone") {
        // Filter props to ensure defaultValue is string only
        var defaultValue = props.defaultValue, restProps = (0,_swc_helpers_src_object_without_properties_mjs__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z)(props, [
            "defaultValue"
        ]);
        var phoneProps = (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, restProps, typeof defaultValue === "string" ? {
            defaultValue: defaultValue
        } : {});
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_PhoneNumberInput__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
            ref: ref,
            label: label,
            error: error,
            helperText: helperText,
            variant: variant,
            size: size,
            fullWidth: fullWidth,
            required: required,
            className: className
        }, phoneProps));
    }
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
        className: "".concat((_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().inputField), " ").concat(fullWidth ? (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().fullWidth) : ""),
        children: [
            label && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                variant: "text-sm",
                as: "label",
                color: error ? "error" : "secondary",
                weight: "normal",
                className: (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().label),
                children: [
                    label,
                    required && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("span", {
                        className: (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().required),
                        children: "*"
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                className: containerClasses,
                children: [
                    renderLeftElement(),
                    multiline ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("textarea", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        ref: ref,
                        className: inputClasses,
                        rows: rows
                    }, props)) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("input", (0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({
                        ref: ref,
                        className: inputClasses,
                        type: inputType === "password" ? showPassword ? "text" : "password" : type || inputType
                    }, props)),
                    renderRightElement()
                ]
            }),
            error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                variant: "text-sm",
                as: "div",
                color: "error",
                weight: "normal",
                className: (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().errorMessage),
                children: error
            }),
            helperText && !error && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_2__/* .Typography */ .ZT, {
                variant: "text-sm",
                as: "div",
                color: "disabled",
                weight: "normal",
                className: (_TextInput_module_scss__WEBPACK_IMPORTED_MODULE_5___default().helperText),
                children: helperText
            })
        ]
    });
});
TextInput.displayName = "TextInput";
/* harmony default export */ __webpack_exports__["Z"] = (TextInput);


/***/ }),

/***/ 31083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputField":"PhoneNumberInput_inputField__eU85N","label":"PhoneNumberInput_label__Vpoh_","required":"PhoneNumberInput_required__avzUP","inputContainer":"PhoneNumberInput_inputContainer__xqLQV","error":"PhoneNumberInput_error__dFbQt","size-sm":"PhoneNumberInput_size-sm__aaRuV","size-md":"PhoneNumberInput_size-md__K5M02","size-lg":"PhoneNumberInput_size-lg__0exSE","fullWidth":"PhoneNumberInput_fullWidth___qNUH","countrySelector":"PhoneNumberInput_countrySelector__1wtTe","countryButton":"PhoneNumberInput_countryButton__rWwPn","countryCode":"PhoneNumberInput_countryCode__zRmRQ","dropdownIcon":"PhoneNumberInput_dropdownIcon__Fu8tC","rotated":"PhoneNumberInput_rotated__WN8YU","dropdownMenu":"PhoneNumberInput_dropdownMenu__AmqPW","dropdownItem":"PhoneNumberInput_dropdownItem__Gb71r","active":"PhoneNumberInput_active__j_D3r","countryFlag":"PhoneNumberInput_countryFlag__72LWK","countryName":"PhoneNumberInput_countryName__HFSwR","countryDialCode":"PhoneNumberInput_countryDialCode__7gngn","divider":"PhoneNumberInput_divider__u2VeQ","input":"PhoneNumberInput_input__cLRvb","errorMessage":"PhoneNumberInput_errorMessage__kKKXu","helperText":"PhoneNumberInput_helperText__97Pf8"};

/***/ }),

/***/ 22083:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"inputField":"TextInput_inputField__h05V4","fullWidth":"TextInput_fullWidth__vI8ez","label":"TextInput_label__mPvTG","error":"TextInput_error__bcYRh","required":"TextInput_required__vyO6M","inputContainer":"TextInput_inputContainer__1IHx0","textareaContainer":"TextInput_textareaContainer__ZkM8W","input":"TextInput_input__jCW35","textarea":"TextInput_textarea__KCZJ6","iconLeft":"TextInput_iconLeft__Xwk99","iconRight":"TextInput_iconRight__NLdIQ","errorMessage":"TextInput_errorMessage__0nZaC","helperText":"TextInput_helperText__omoaq","inputType-email":"TextInput_inputType-email__hZfTA","inputType-phone":"TextInput_inputType-phone__vSV9U","inputType-website":"TextInput_inputType-website__rNQ6d","inputType-card":"TextInput_inputType-card__vzOne","inputType-users":"TextInput_inputType-users__r_R57","phoneCountrySelector":"TextInput_phoneCountrySelector__I1RD_","countryFlag":"TextInput_countryFlag__Qt5xn","countrySelect":"TextInput_countrySelect__DF497","phoneNumberContainer":"TextInput_phoneNumberContainer__XHShb","countryCode":"TextInput_countryCode___uEEg","websiteProtocol":"TextInput_websiteProtocol__AZDLC","protocolSelect":"TextInput_protocolSelect__Eu1Fn","usersContainer":"TextInput_usersContainer__XoUqf","userTag":"TextInput_userTag__Hic8g","userName":"TextInput_userName__uthaw","removeUserButton":"TextInput_removeUserButton__BZilb","passwordToggle":"TextInput_passwordToggle___DzCP","focused":"TextInput_focused__LXD7B"};

/***/ })

}]);